import {SearchOutlined} from '@ant-design/icons';
import React, {useRef} from 'react';
import {DatePicker} from 'antd';
import {useSelector} from "react-redux";
import locale from "antd/es/date-picker/locale/fa_IR";
import dayjs from 'dayjs'

const {RangePicker} = DatePicker;


const DateFilterTable = () => {
    const searchInput = useRef(null);
    const filter = useSelector((state) => state.TableRedux.filter);

    // function onChange(value, dateString) {
    // }


    const getColumnDateProps = (initialValue = [], callbackData, dataIndex, showTime = {format: 'HH:mm'}) => ({
        filterDropdown: (/*{setSelectedKeys, selectedKeys, confirm,  clearFilters}*/) => {

            // console.log(initialValue[0])
            const from = !!initialValue[0] && dayjs(initialValue[0])
            const end = !!initialValue[1] && dayjs(initialValue[1])

            return <div
                style={{
                    padding: 8, width: '300px'
                }}
            >

                <div>
                    <RangePicker
                        locale={{
                            ...locale, lang: {
                                ...locale.lang, ok: "تایید",
                            }
                        }}

                        defaultValue={[from, end]}
                        popupClassName='datePickerBtn'
                        showTime={showTime}
                        format="YYYY-MM-DD HH:mm"
                        placeholder={['شروع زمان', 'اتمام زمان']}
                        onChange={(e) => {


                            callbackData({'from_date': e ? e[0] : '', 'end_date': e ? e[1] : ''})


                        }}
                    />
                </div>


            </div>
        }, filterIcon: (filtered) => (<SearchOutlined
            style={{
                color: filter[dataIndex] ? 'blue' : undefined,
            }}
        />), onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
    });


    return [getColumnDateProps];
};

export default DateFilterTable;






